import React, { Component } from 'react';
import Grid from '@material-ui/core/Grid';
import CardFenomene from './../../../fenomene_selection/components/CardFenomene';
import './cliente.css';
import { TIME_SELECTION_CONTAINER } from './../../../../../constants/strings/StringsDashboard';
//import {ARMA_DROGA} from '../../../constants/icons/characteristics';
import ButtonBox from './ButtonBox'

class SemesterSelect extends Component {
    render() {
        return (
            <Grid>
                <Grid>
                    <CardFenomene
                        title={TIME_SELECTION_CONTAINER.SEMESTER}
                        groupbutton={
                            <Grid className="iconContainerFS" >
                                <Grid>
                                    <ButtonBox
                                        className="semester"
                                        value={TIME_SELECTION_CONTAINER.JANUARY_JUNE}
                                        id={1}
                                        group="semester"
                                    />
                                    <ButtonBox
                                        className="semester"
                                        value={TIME_SELECTION_CONTAINER.JULY_DECEMBER}
                                        id={2}
                                        group="semester"
                                    />
                                </Grid>
                            </Grid>
                        }
                    />
                </Grid>
            </Grid>
        )
    }
}

export default SemesterSelect;